import { sessionmgrPublicPath } from "@/api/servicePaths";
import { CodeModalProps } from "@/components/tasks/CodeModal";

import FETCH from "../fetch";
import FETCHRAW from "../fetchRaw";

const PAGE_CHAT_PATH = sessionmgrPublicPath("/sess/v1/chat/page");

const buildPageChatPath = (suffix = "") => `${PAGE_CHAT_PATH}${suffix}`;

// get list message from db (sent from user or sent to user)
export const getMessages = (params: { sentFrom: string; sentTo: string }) =>
  FETCH("mock", "/message", "GET", {}, {}, params);

// send new message to db
export const pushMessages = (body: { sentFrom: string; sentTo: string; content: string; createdAt: string }) =>
  FETCH("mock", "/message", "GET", {}, body);

export const newChat = ({ body, page_src }) =>
  FETCHRAW({
    type: "apiChatUrl",
    path: sessionmgrPublicPath(`/sess/v1/chat/${page_src}`),
    method: "POST",
    body: JSON.stringify(body)
  });

export const newPageChat = ({ body }: { body: Record<string, unknown> }) =>
  FETCHRAW({
    type: "apiChatUrl",
    path: PAGE_CHAT_PATH,
    method: "POST",
    body: JSON.stringify(body)
  });

export const followingChat = ({ body, page_src, id }) =>
  FETCHRAW({
    type: "apiChatUrl",
    path: sessionmgrPublicPath(`/sess/v1/chat/${page_src}${id ? "/" + id : ""}`),
    method: "POST",
    body: JSON.stringify(body)
  });

export const followingPageChat = ({ body, id }: { body: Record<string, unknown>; id?: string | null }) =>
  FETCHRAW({
    type: "apiChatUrl",
    path: buildPageChatPath(id ? `/${id}` : ""),
    method: "POST",
    body: JSON.stringify(body)
  });

export const getTaskStatus = (id: string) =>
  FETCHRAW({
    type: "apiChatUrl",
    path: sessionmgrPublicPath(`/sess/v1/chat/${id}/status`),
    method: "GET"
  });

export const getChatBubbles = ({
  page_src,
  id,
  // user_id,
  params
}: {
  page_src: string;
  id: string;
  // user_id: string;
  params?: {
    limit?: number;
    timestamp_lower_bound?: string;
  };
}) =>
  FETCHRAW({
    type: "apiChatUrl",
    path: sessionmgrPublicPath(`/sess/v1/chat/${page_src}/${id}/`),
    method: "GET",
    params
  });

export const getPageChatBubbles = ({
  id,
  params
}: {
  id: string;
  params?: {
    limit?: number;
    timestamp_lower_bound?: string;
  };
}) =>
  FETCHRAW({
    type: "apiChatUrl",
    path: buildPageChatPath(`/${id}/`),
    method: "GET",
    params
  });

export const getEventsource = ({ page_src, id }) =>
  FETCHRAW({
    type: "apiChatUrl",
    path: sessionmgrPublicPath(`/sess/v1/chat/${page_src}/eventsource/${id}/get/`),
    method: "GET"
  });
interface QuickReply {
  action_type: string;
  action_url: string;
  image_url: string | null;
  payload: string;
  postback_data: {} | null;
  title: string;
}
export const postBackQuickReply = (value: QuickReply) =>
  FETCHRAW({
    type: "apiurl",
    path: value.action_url,
    method: "POST",
    body: value.payload
  });
export const getCodeData = (path) =>
  FETCHRAW({
    type: "apiurl",
    path: path,
    method: "GET"
  });
export const updateCodeData = (codeData: CodeModalProps) =>
  FETCHRAW({
    type: "apiurl",
    path: codeData.action_url,
    method: "PUT",
    body: JSON.stringify(codeData.data)
  });
